import { render } from "./flow.vue?vue&type=template&id=1ebf2f5a&scoped=true"
import script from "./flow.vue?vue&type=script&lang=js"
export * from "./flow.vue?vue&type=script&lang=js"

import "./flow.vue?vue&type=style&index=0&id=1ebf2f5a&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ebf2f5a"]])

export default __exports__